import { getLocale } from '../../utils/pathHelper';

export type TranslationKeys =
'filterLessons'|
'found' |
'notFound'|
'dateRange'|
'skiResort'|
'language'|
'subject'|
'participantType'|
'chinese'|
'english'|
'japanese' |
'ski'|
'snowboard'|
'private'|
'group'|
'book'|
'pleaseSelect'|
'participantCount';


type TranslationLocales = 'en'|'ja'|'zh-CN'|'zh-HK'|'zh-TW';

export type ITranslation = {
  [key in TranslationKeys]: ({}?: { [arg: string]: string|number }) => string;
}

const locales: {
  [locale in TranslationLocales]: ITranslation
} = {
  'en': {
    filterLessons: () => ('Filter Lessons'),
    found: ({ count }) => (`${count} Lesson${count > 1 ? 's' : ''} Found.`),
    notFound: () => ('No Lessons Found'),
    dateRange: () => ('Date'),
    skiResort: () => ('Ski Resort'),
    language: () => ('Language'),
    subject: () => ('Ski/Snowboard'),
    participantType: () => ('Lesson Type'),
    chinese: () => ('Chinese'),
    english: () => ('English'),
    japanese: () => ('Japanese'),
    ski: () => ('Ski'),
    snowboard: () => ('Snowboard'),
    private: () => ('Private lesson'),
    group: () => ('Group lesson'),
    book: () => ('Book'),
    pleaseSelect: () => ('Please Select'),
    participantCount: () => ('Number of people'),
  },
  'ja': {
    filterLessons: () => ('レッスンを絞り込む'),
    found: ({ count }) => (`レッスンが ${count} 件見つかりました。`),
    notFound: () => ('レッスンが見つかりませんでした。'),
    dateRange: () => ('日付'),
    skiResort: () => ('スキー場'),
    language: () => ('対応言語'),
    subject: () => ('課目'),
    participantType: () => ('参加タイプ'),
    chinese: () => ('中国語'),
    english: () => ('英語'),
    japanese: () => ('日本語'),
    ski: () => ('スキー'),
    snowboard: () => ('スノーボード'),
    private: () => ('プライベートレッスン'),
    group: () => ('グループレッスン'),
    book: () => ('予約する'),
    pleaseSelect: () => ('選択してください'),
    participantCount: () => ('人数'),
  },
  'zh-CN': {
    filterLessons: () => ('课程进阶筛选'),
    found: ({ count }) => (`课程搜寻结果共 ${count} 笔。`),
    notFound: () => ('没有符合条件的课程。'),
    dateRange: () => ('日期'),
    skiResort: () => ('滑雪场'),
    language: () => ('对应语言'),
    subject: () => ('课程内容'),
    participantType: () => ('参加类型'),
    chinese: () => ('中文'),
    english: () => ('英语'),
    japanese: () => ('日语'),
    ski: () => ('双板滑雪'),
    snowboard: () => ('单板滑雪'),
    private: () => ('私人课程'),
    group: () => ('团体课程'),
    book: () => ('预约'),
    pleaseSelect: () => ('请选择'),
    participantCount: () => ('人数'),
  },
  'zh-HK': {
    filterLessons: () => ('課程篩選'),
    found: ({ count }) => (`找到${count} 個課程。`),
    notFound: () => ('找不到符合條件的課程。'),
    dateRange: () => ('日期'),
    skiResort: () => ('滑雪場'),
    language: () => ('對應語言'),
    subject: () => ('課程內容'),
    participantType: () => ('參加形式'),
    chinese: () => ('中文'),
    english: () => ('英文'),
    japanese: () => ('日文'),
    ski: () => ('雙板滑雪'),
    snowboard: () => ('單板滑雪'),
    private: () => ('私人課程'),
    group: () => ('團體課程'),
    book: () => ('預約'),
    pleaseSelect: () => ('請選擇'),
    participantCount: () => ('人數'),
  },
  'zh-TW': {
    filterLessons: () => ('課程進階篩選'),
    found: ({ count }) => (`課程搜尋結果共 ${count} 筆。`),
    notFound: () => ('沒有符合條件的課程。'),
    dateRange: () => ('日期'),
    skiResort: () => ('滑雪場'),
    language: () => ('對應語言'),
    subject: () => ('課程內容'),
    participantType: () => ('參加類型'),
    chinese: () => ('中文'),
    english: () => ('英文'),
    japanese: () => ('日文'),
    ski: () => ('雙板滑雪'),
    snowboard: () => ('單板滑雪'),
    private: () => ('私人課程'),
    group: () => ('團體課程'),
    book: () => ('預約'),
    pleaseSelect: () => ('請選擇'),
    participantCount: () => ('人數'),
  },
};

const t: ITranslation = locales[getLocale() || 'en'];

export default t;
